import * as React from "react";
import type { SVGProps } from "react";
const SvgUserField = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="#050033"
      fillOpacity={0.2}
      d="M9 0a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 11.25c4.973 0 9 2.014 9 4.5V18H0v-2.25c0-2.486 4.028-4.5 9-4.5"
    />
  </svg>
);
export default SvgUserField;
